"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _color = _interopRequireDefault(require("../oneflare/color"));
var _font = _interopRequireDefault(require("../oneflare/font"));
var _default = exports.default = {
  backgroundColor: 'rgba(238, 238, 238, 0.5)',
  linkColor: _color.default.infoDark,
  defaultBold: 700,
  defaultLineHeight: '24px',
  headingFont: _font.default.secondaryBold,
  padding: '24px',
  timestampColor: _color.default.spaceGrey
};